import { createApi } from '@reduxjs/toolkit/query/react'

import { rtkBaseQuery } from 'Src/api'

export const releaseNotesApi = createApi({
  baseQuery: rtkBaseQuery,
  reducerPath: 'releaseNotesApi',
  tagTypes: ['ReleaseNotes', 'ReleaseNote'],
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    listReleaseNotes: builder.query({
      query: (params) => {
        return {
          url: `/v1/release-notes/`,
          method: 'GET',
          params
        }
      },
      providesTags: ['ReleaseNotes']
    }),
    getReleaseNoteById: builder.query({
      query: (id) => `/v1/release-notes/${id}`,
      providesTags: ['ReleaseNote']
    }),
    createReleaseNote: builder.mutation({
      query: (payload) => {
        return {
          url: '/v1/release-notes',
          method: 'POST',
          body: payload
        }
      },
      invalidatesTags: ['ReleaseNotes']
    }),
    updateReleaseNote: builder.mutation({
      query: (data) => {
        const { id, ...payload } = data

        return {
          url: `/v1/release-notes/${id}`,
          method: 'PATCH',
          body: payload
        }
      },
      invalidatesTags: ['ReleaseNote']
    }),
    deleteReleaseNote: builder.mutation({
      query: (id) => {
        return {
          url: `/v1/release-notes/${id}`,
          method: 'DELETE'
        }
      },
      invalidatesTags: ['ReleaseNotes', 'ReleaseNote']
    }),
    uploadImage: builder.mutation({
      query: (data) => {
        return {
          url: 'v1/release-notes/upload/',
          method: 'POST',
          body: data
        }
      },
      invalidatesTags: ['ReleaseNote']
    })
  })
})

export const {
  useListReleaseNotesQuery,
  useGetReleaseNoteByIdQuery,
  useCreateReleaseNoteMutation,
  useUpdateReleaseNoteMutation,
  useDeleteReleaseNoteMutation,
  useUploadImageMutation
} = releaseNotesApi

export default releaseNotesApi
